export default __webpack_public_path__ + "static/media/spinner-1.8981e9a5.gif";